import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import strings from 'strings';

export const MAX_FILE_SIZE = 1024 * 1024 * 3; // 3 MB

export const SEARCH_TYPES = {
  contact: 'contact',
  message: 'message'
};

export const DEFAULT_MESSAGE_STATUS = 'defaultStatus';

export const MESSAGE_STATUS_ID = {
  sending: 1,
  delivered: 2,
  failed: 3,
  optedOut: 4,
  partialFailure: 5,
  partialOptOut: 6,
  [DEFAULT_MESSAGE_STATUS]: DEFAULT_MESSAGE_STATUS
};
export const MESSAGE_FAILURE_STATUSES = [
  MESSAGE_STATUS_ID.failed,
  MESSAGE_STATUS_ID.optedOut,
  MESSAGE_STATUS_ID.partialFailure,
  MESSAGE_STATUS_ID.partialOptOut
];
export const MESSAGE_STATUS_COPIES = {
  [MESSAGE_STATUS_ID.sending]: strings.messageCenter.error.default,
  [MESSAGE_STATUS_ID.delivered]: strings.messageCenter.error.default,
  [MESSAGE_STATUS_ID.failed]: strings.messageCenter.error.default,
  [MESSAGE_STATUS_ID.optedOut]: strings.messageCenter.error.optedOut,
  [MESSAGE_STATUS_ID.partialFailure]: strings.messageCenter.error.default,
  [MESSAGE_STATUS_ID.partialOptOut]: strings.messageCenter.error.default,
  [DEFAULT_MESSAGE_STATUS]: ''
};

export const MESSAGE_STATUS = Object.freeze({
  delivered: 'delivered',
  received: 'received',
  sending: 'sending',
  error: 'error',
  success: 'success'
});

export const MESSAGE_READ_STATUS = {
  all: 'all',
  read: 'read',
  unread: 'unread'
};
export const MESSAGE_READ_STATUS_ID = {
  read: 0,
  unread: 1
};
export const FILTER_KEYS = {
  readStatus: 'readStatus'
};

export const MESSAGE_DIRECTION_PARAM = Object.freeze({
  DESC: 'DESC',
  ASC: 'ASC'
});

export const NON_RETRYABLE_HTTP_CODES = [
  HTTPStatusCodes.BadRequest,
  HTTPStatusCodes.Forbidden,
  HTTPStatusCodes.UnprocessableContent
];
